// 取得済み謄本の変動アラート画面の定数・文言。

/** 画面ルート（App のルート定義・セクションのリンク先の正本）。 */
export const REGISTRY_CHANGE_ALERT_PATH = "/registry-change-alerts";

/** 画面タイトル。 */
export const REGISTRY_CHANGE_ALERT_TITLE = "取得済み登記の変動アラート";

/** 画面の説明。 */
export const REGISTRY_CHANGE_ALERT_DESCRIPTION =
  "過去に取得した登記より新しい登記がリユースで取得できるようになり、内容に変動がある物件です。";

/** リユース取得の注記。 */
export const REGISTRY_CHANGE_ALERT_ACQUIRE_NOTE =
  "リユース取得では、一覧の新しい登記をそのまま取得します（新規の取得は行いません）。";

/** 一度に取得する一覧の件数（全件をまとめて取得する際のページ単位。BE の上限）。 */
export const FETCH_ALL_PAGE_SIZE = 100;

/** 1 回の取得依頼に載せる物件数の上限（登記取得依頼 API の上限）。 */
export const MAX_ITEMS_PER_ACQUIRE_REQUEST = 1000;

/** 一覧の既定件数・選択肢。 */
export const DEFAULT_PAGE_SIZE = 20;
export const ROWS_PER_PAGE_OPTIONS = [20, 50, 100];

/**
 * 謄本種別の絞り込みで「すべて」を表す値。
 * MUI の Select は空文字を「未選択」として扱い、選んでも表示が空になるため、空文字は使わない。
 */
export const PICTURE_TYPE_FILTER_ALL = "ALL";

/** 謄本種別の絞り込み。 */
export const PICTURE_TYPE_FILTER_OPTIONS = [
  { value: PICTURE_TYPE_FILTER_ALL, label: "すべて" },
  { value: "SHOYUSHAJIKO", label: "所有者事項" },
  { value: "ZENBUJIKO", label: "全部事項" },
];
